import React from 'react';
import SECTIONS from 'src/utils/sectionConstants';
import RedirectAction from 'components/CTA/RedirectAction';
import DownloadAction from 'components/CTA/DownloadAction';
import OpenFormAction from 'components/CTA/OpenFormAction';
import DynamicRedirectAction from 'components/CTA/DynamicRedirectAction';
import STYLES from 'src/utils/stylesConstants';
import { useAuth0 } from '@auth0/auth0-react';

const CTA = ({
  callToActions,
  extraStyle,
  isTextWithOrPrefix,
  title,
  pageTitle,
}) => {
  const buttonStyle = action => {
    switch (action?.style) {
      case STYLES.buttons.blackNoBg:
        return 'app-default-button';
      case STYLES.buttons.redNoBg:
        return 'app-transparent-red-button';
      case STYLES.buttons.whiteNoBg:
        return 'app-transparent-white-button';
      case STYLES.buttons.redWhiteBg:
        return 'app-default-white-button no-border mw-100';
      case STYLES.buttons.whiteRedBg:
        return 'app-primary-button no-border';
      default:
        return 'app-default-button';
    }
  };

  const linkStyle =
    'button app-white-link-button justify-content-start text-left mw-100';

  const downloadBtnStyle = `${linkStyle} download-button`;

  const renderAction = (action, index, prevAction) => {
    switch (action.action?.__typename) {
      case SECTIONS.RedirectAction:
        return (
          <RedirectAction
            key={`cta${index}`}
            buttonStyle={buttonStyle(action)}
            linkStyle={linkStyle}
            callToAction={action}
            prevAction={prevAction}
            extraStyle={extraStyle}
            isTextWithOrPrefix={isTextWithOrPrefix}
            title={title}
            pageTitle={pageTitle}
          />
        );
      case SECTIONS.DynamicRedirectAction:
        return (
          <DynamicRedirectAction
            key={`cta${index}`}
            buttonStyle={buttonStyle(action)}
            linkStyle={linkStyle}
            callToAction={action}
            prevAction={prevAction}
            extraStyle={extraStyle}
            isTextWithOrPrefix={isTextWithOrPrefix}
          />
        );
      case SECTIONS.DownloadAction:
        return (
          <DownloadAction
            key={`cta${index}`}
            buttonStyle={buttonStyle(action)}
            linkStyle={downloadBtnStyle}
            callToAction={action}
            prevAction={prevAction}
            extraStyle={extraStyle}
            isTextWithOrPrefix={isTextWithOrPrefix}
          />
        );
      case SECTIONS.OpenFormAction:
        return (
          <OpenFormAction
            key={`cta${index}`}
            buttonStyle={buttonStyle(action)}
            linkStyle={linkStyle}
            callToAction={action}
            prevAction={prevAction}
            extraStyle={extraStyle}
            isTextWithOrPrefix={isTextWithOrPrefix}
          />
        );
      default:
        return '';
    }
  };

  return (
    <>
      {callToActions?.length &&
        callToActions.map((action, index) =>
          renderAction(action, index, callToActions[index - 1]?.style)
        )}
    </>
  );
};

export default CTA;
